import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AngularFireAuth } from "@angular/fire/auth";
import { of, from } from "rxjs";
import { mergeMap, catchError, map, delay } from "rxjs/operators";
import { Observable } from "rxjs";
import {
  AngularFirestore,
  AngularFirestoreDocument
} from "@angular/fire/firestore";

@Injectable({
  providedIn: "root"
})
export class AuthenticationService implements CanActivate {
  userData: Observable<firebase.User>;
  user = {
    uid: "",
    name: "",
    email: "",
    operationType: "",
    lastModified: ""
  };
  auth: boolean;

  constructor(
    private db: AngularFirestore,
    private angularFireAuth: AngularFireAuth,
    private router: Router
  ) {
    this.userData = angularFireAuth.authState;
  }

  canActivate() {
    return this.authenticate().pipe(
      map(res => {
        if (!res.error) {
          return true;
        }
        this.router.navigate(["signin"]);
        return false;
      })
    );
  }

  public addHistory(operationType) {
    // Add to History
    const userRef = this.db
      .collection("dev_history")
      .doc(this.user.email.length ? this.user.email : "signin")
      .collection("movements")
      .doc(new Date().toJSON());
    this.user.operationType = operationType;
    this.user.lastModified = new Date().toLocaleString();
    userRef.set(this.user);
  }

  authenticate() {
    return this.angularFireAuth.authState.pipe(
      map(data => {
        if (data == null) {
          this.auth = false;
          return { error: true };
        }

        this.auth = true;
        this.user.email = data.email;
        this.user.uid = data.uid;

        return { error: false };
      })
    );
  }

  /* Sign up */
  SignUp(email: string, password: string) {
    this.angularFireAuth.auth
      .createUserWithEmailAndPassword(email, password)
      .then(res => {
        this.addHistory("Created user with email: " + email);
        console.log("Successfully signed up!", res);
      })
      .catch(error => {
        console.log("Something is wrong:", error.message);
      });
  }

  /* Sign in */
  SignIn(email: string, password: string) {

    return this.angularFireAuth.auth.signInWithEmailAndPassword(
      email,
      password
    );
  }

  /* Sign out */
  SignOut() {
    this.addHistory("Signout");
    this.angularFireAuth.auth.signOut();
    this.router.navigate(["signin"]);
  }
}
